R = require 'ramda'
import bugsnagClient from 'utils/bugsnag'

errorReporter = R.curry (module, data) ->
  report =
    params: window.page_config
    url: window.location.href
    error: data

  console.log "Error Detected", module, report
  if bugsnagClient and bugsnagClient.notify
    bugsnagClient.notify module, JSON.stringify(report || "No further data")

module.exports = { errorReporter }
